import React from 'react';
import { Button, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';

const StyledButton = styled(Button)(({ theme, backgroundcolor, textcolor }) => ({
  width: '100%',
  padding: theme.spacing(2, 2.5),
  backgroundColor: backgroundcolor || '#1976d2',
  color: textcolor || '#fff',
  border: 'none',
  borderRadius: theme.spacing(1.5),
  fontSize: '18px',
  fontWeight: 600,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
  margin: '0 auto',
  maxWidth: '400px',
  position: 'relative',
  overflow: 'hidden',
  textTransform: 'none',

  '&:hover': {
    backgroundColor: backgroundcolor || '#1976d2',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  },

  '&:active': {
    transform: 'none',
  },

  '&:focus': {
    outline: 'none',
  },

  '&.Mui-focusVisible': {
    boxShadow: '0 4px 12px rgba(0,0,0,0.15), 0 0 0 2px rgba(255,255,255,0.75)',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    padding: theme.spacing(2),
  },
}));

const MobileSearchButton = ({ onClick, text, backgroundColor, textColor }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <StyledButton
        onClick={onClick}
        disableRipple
        className='mobile-search-button'
        backgroundcolor={backgroundColor}
        textcolor={textColor}
        startIcon={null}
        endIcon={<SearchIcon sx={{ fontSize: '18px' }} />}
      >
        <span style={{ fontSize: '16px' }}>{text}</span>
      </StyledButton>
    </Box>
  );
};

export default MobileSearchButton;
